<div class="title">{{ "deposit-limit-calculator.title" | translate }}</div>

<div class="content">
	{{ "deposit-limit-calculator.info" | translate }}
</div>

<div class="close-button">
	<button type="button" (click)="closeDialog()" mat-flat-button color="primary" test-id="deposit-limit-calculator-ok">
		{{ "general.ok" | translate }}
	</button>
</div>
